import React, { useEffect } from "react";
import RouterConfig from "./core/routing/routeConfig";
// redux
import { Provider } from "react-redux";
import store from "./core/redux/store";
// contexts
import LoadingProvider from "./core/contexts/loading/loading";
import MaterialTheme from "./core/contexts/materialTheme/materialTheme";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AppInitialize from "./core/appInit/appIniti";

function App() {
  return (
    <div className="App m-0 p-0">
      <ToastContainer
        rtl={true}
        style={{
          right: "0",
          zIndex: "1000000000",
          width: "355px",
          fontFamily: "iransans",
        }}
        className="font-iransans text-nowrap"
      />
      <MaterialTheme>
        <Provider store={store}>
          <LoadingProvider>
            <AppInitialize>
              <RouterConfig />
            </AppInitialize>
          </LoadingProvider>
        </Provider>
      </MaterialTheme>
    </div>
  );
}

export default App;
